import React, { useEffect, useState } from "react";
import "./RecruiterHeader.scss";
import englishFlag from "@assets/img/flags/english.png";
import { Link, useNavigate } from "react-router-dom";
import { Avatar, Badge, Divider, Dropdown, MenuProps, Switch } from "antd";
import {
  LogoutOutlined,
  PhoneOutlined,
  SettingOutlined,
  UserOutlined,
} from "@ant-design/icons";
import Helpers from "@utils/Helpers";
import { useAuth } from "context/AuthContext";
import { useUser } from "context/UserContext";
import { useTour } from "@reactour/tour";
import EngineSwitch from "./EngineSwitch/EngineSwitch";

const RecruiterHeader: React.FC = () => {
  const { isOpen, setIsOpen } = useTour();
  const { logout } = useAuth();
  const navigate = useNavigate();
  const { userProfile } = useUser();

  const logOut = () => {
    Helpers.clearToken();
    Helpers.removeUserInfo();
    logout();
    navigate("/auth/login");
  };

  // Define the menu items
  const menuItems: MenuProps["items"] = [
    {
      key: "role",
      label: (
        <div className="profile-dropdown">
          <div className="profile-background">
            <img src="https://asset.gecdesigns.com/img/wallpapers/beautiful-fantasy-wallpaper-ultra-hd-wallpaper-4k-sr10012418-1706506236698-cover.webp" />
          </div>
          <div className="profile-avatar">
            {userProfile?.avatar ? (
              <Avatar src={userProfile.avatar} size={60} />
            ) : (
              <Avatar
                className="rounded-circle"
                size={60}
                style={{
                  backgroundColor: "#fde3cf",
                  color: "#f56a00",
                }}
              >
                {userProfile?.display_name[0]}
              </Avatar>
            )}
          </div>
          <div className="profile-info">
            <span className="name">{userProfile?.display_name}</span>
            <br />
            <span className="position">Product Designer</span>
          </div>
        </div>
      ),
    },
    {
      type: "divider",
    },
    {
      key: "recruiter",
      label: (
        <div>
          <input
            type="radio"
            name="role"
            checked
            onChange={() => console.log(1)}
          />{" "}
          Recruiter
        </div>
      ),
    },
    {
      key: "talent",
      label: (
        <div>
          <input type="radio" name="role" onChange={() => console.log(1)} />{" "}
          Talent
        </div>
      ),
    },
    {
      type: "divider",
    },
    {
      key: "account",
      label: "Account",
      icon: <UserOutlined />,
      onClick: () => navigate("profile"),
    },
    {
      key: "support",
      label: "Support",
      icon: <PhoneOutlined />,
    },
    {
      key: "setting",
      label: "Setting",
      icon: <SettingOutlined />,
    },
    {
      type: "divider",
    },
    {
      key: "logout",
      label: "Sign Out",
      icon: <LogoutOutlined />,
      onClick: logOut,
    },
  ];

  return (
    <div className="RecruiterHeader px-0 bg-white">
      <div className="container-fluid h-100 header-group">
        <div className="menu-header">
          <Link to="/">Home</Link>
          <Link to="/">Branches</Link>
          <Link to="/">About Us</Link>
          <Link to="/">News</Link>
          <EngineSwitch />
          <div className="guided-tour-control">
            <span className="me-2">Guided Tour</span>
            <label className="switch">
              <input
                checked={isOpen}
                onChange={(e) => setIsOpen(e.target.checked)}
                type="checkbox"
              />
              <div className="slider"></div>
              <div className="slider-card">
                <div className="slider-card-face slider-card-front"></div>
                <div className="slider-card-face slider-card-back"></div>
              </div>
            </label>
          </div>
        </div>
        <Divider className="divider" type="vertical" />
        <div className="user-control-header">
          <img className="img-fluid rounded-3" width={30} src={englishFlag} />
          <Badge count={5} size="small">
            <i className="fa-regular fa-bell"></i>
          </Badge>
          <Badge count={8} size="small">
            <i className="fa-regular fa-message"></i>
          </Badge>
          <Dropdown
            menu={{ items: menuItems }}
            trigger={["click"]}
            placement="bottomRight"
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <a onClick={(e) => e.preventDefault()}>
                {userProfile?.avatar ? (
                  <Avatar size={40} src={userProfile.avatar} shape="square" />
                ) : (
                  <Avatar
                    size={40}
                    shape="square"
                    style={{
                      backgroundColor: "#fde3cf",
                      color: "#f56a00",
                    }}
                  >
                    {userProfile?.name[0]}
                  </Avatar>
                )}
              </a>
            </div>
          </Dropdown>
        </div>
      </div>
    </div>
  );
};

export default RecruiterHeader;
